import * as React from "react";
import { SVGProps } from "react";

const PolkadotNew = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Logo"
    x={0}
    y={0}
    viewBox="0 0 1326 1410"
    {...props}
  >
    <style>{".st0{fill:#e6007a}"}</style>
    <ellipse cx={663} cy={147.9} className="st0" rx={254.3} ry={147.9} />
    <ellipse cx={663} cy={1262.3} className="st0" rx={254.3} ry={147.9} />
    <ellipse
      cx={180.5}
      cy={426.5}
      className="st0"
      rx={254.3}
      ry={148}
      transform="rotate(-60 180.499 426.56)"
    />
    <ellipse
      cx={1145.6}
      cy={983.7}
      className="st0"
      rx={254.3}
      ry={147.9}
      transform="rotate(-60 1145.575 983.768)"
    />
    <ellipse
      cx={180.5}
      cy={983.7}
      className="st0"
      rx={148}
      ry={254.3}
      transform="rotate(-30 180.45 983.72)"
    />
    <ellipse
      cx={1145.6}
      cy={426.6}
      className="st0"
      rx={147.9}
      ry={254.3}
      transform="rotate(-30 1145.522 426.601)"
    />
  </svg>
);

export default PolkadotNew;
